import { useState } from 'react';

import { GrupoDeChips } from '../ds/GrupoDeChips.js';
import { gravarTema, lerTema, type Tema as Escolha } from '../pwa/tema.js';
import './ajustes.css';

const OPCOES: ReadonlyArray<{ valor: Escolha; rotulo: string }> = [
  { valor: 'sistema', rotulo: 'Sistema' },
  { valor: 'claro', rotulo: 'Claro' },
  { valor: 'escuro', rotulo: 'Escuro' },
];

export function Tema() {
  const [tema, setTema] = useState<Escolha>(lerTema);
  return (
    <section className="ajustes__secao">
      <GrupoDeChips
        nome="tema"
        rotulo="Tema"
        opcoes={OPCOES}
        valor={tema}
        aoMudar={(valor) => {
          setTema(valor);
          gravarTema(valor);
        }}
      />
    </section>
  );
}
